import { whatsappUrl } from "../../shared/phone";
export function WhatsAppAction({
  phone,
  name,
  compact = false,
}: {
  phone: string;
  name: string;
  compact?: boolean;
}) {
  const href = whatsappUrl(phone);
  if (!href) return null;
  return (
    <a
      className={compact ? "phone-action icon-button" : "whatsapp-action"}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={"WhatsApp " + name}
      title={"WhatsApp " + name}
    >
      <svg
        viewBox="0 0 24 24"
        width="19"
        height="19"
        aria-hidden="true"
        fill="currentColor"
      >
        <path d="M20.52 3.48A11.85 11.85 0 0 0 12.06 0C5.48 0 .12 5.35.12 11.93c0 2.1.55 4.15 1.6 5.96L0 24l6.27-1.64a11.95 11.95 0 0 0 5.78 1.48h.01C18.64 23.84 24 18.5 24 11.92c0-3.19-1.24-6.18-3.48-8.44ZM12.06 21.83a9.9 9.9 0 0 1-5.04-1.38l-.36-.22-3.72.98.99-3.63-.24-.38a9.86 9.86 0 0 1-1.51-5.27c0-5.47 4.45-9.92 9.93-9.92a9.84 9.84 0 0 1 7.02 2.91 9.85 9.85 0 0 1 2.91 7.01c0 5.47-4.45 9.9-9.98 9.9Zm5.45-7.42c-.3-.15-1.76-.87-2.03-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.22 1.36.19 1.87.11.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.3.18-1.42-.08-.13-.28-.2-.58-.35Z" />
      </svg>
      {!compact && <span>WhatsApp</span>}
    </a>
  );
}
